import $ from 'jquery';
import contextGet from './context.get';
import blocks from './blocks/index';
import trigger from './trigger';
import config from './config';
/*
  expects only a scope param
  scope param doubles as a maxium parent to traverse up,
  used in getting the entire context that this link lives within
*/
export default function anClick(scope) {
  var $scope = $(scope);

  /*
  Slick dots:
    Slick events need to happen first. Slick adds its clicks to the LI of each dot.
    therefore we CANNOT add our aa-clicks to the button within each LI, else those would happen first
    so for these, we attach our aa click event to parent LI, and modify the start context to the button within
    Also note:
      The BAT wrapper for slick, "Slicker", is where we provide Slick with this default, custom pagination
  */
  $('.datalayer-link-slick-dot', $scope)
    .parent('li')
    .on('click', function boundDlClickSlidDot() {
      if (config.debug && config.debug.logClicks) {
        console.log('DL 1.5 click');
      }
      var $this = $(this);
      var $modifiedStartCtx = $this.children('.datalayer-link-slick-dot');
      // todo: move out for sharing with below
      trigger('aa-link', [
        contextGet($modifiedStartCtx, $scope), // provide start and end contexts
        blocks.linkBlock($modifiedStartCtx)
      ]);
    });

  /*
    Need to use event.stopPropagation to prevent these new DL clicks from bubbling up past their $scope
    This prevents the old datalayer click events, which are delegated on $(document)
    this WILL be a problem however,
    if any click events within our $scope are delegated on a node higher than $scope
  */
  $scope.off('click.datalayer').on('click.datalayer', '.datalayer-link', function delegatedDlClick(e) {
    if (config.preventClicks) {
      e.preventDefault();
    }
    if (config.debug && config.debug.logClicks) {
      console.log('DL 1.5 click');
    }
    var $this = $(this);
    trigger('aa-link', [
      contextGet($this, $scope), // provide start and end contexts
      blocks.linkBlock($this)
    ]);
  });
};
